import React from "react"
export function Invoice(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M16.498 1.749a.75.75 0 01.743.648l.007.102v15a.75.75 0 01-1.185.61l-.083-.068-1.648-1.574-1.652 1.574a.75.75 0 01-.844.133l-.1-.058-.091-.075-1.649-1.574-1.649 1.574a.75.75 0 01-.844.133l-.1-.058-.092-.075-1.648-1.573-1.647 1.573a.75.75 0 01-1.26-.436l-.008-.106v-15a.75.75 0 01.648-.744l.102-.006h13zm-.75 1.5h-11.5v12.496l.897-.858a.75.75 0 01.844-.133l.1.058.092.075 1.65 1.575 1.647-1.575a.75.75 0 01.845-.133l.1.058.091.075 1.65 1.576 1.65-1.576a.75.75 0 01.944-.075l.092.075.898.859V3.249zm-4.5 5.501v1.5h-5.5v-1.5h5.5zm2.5-3v1.5h-8v-1.5h8z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__invoice"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
